<script setup>

import TextInput from "@/components/common/input/TextInput.vue";
import MultiSearchDropDown from "@/components/common/input/MultiSearchDropDown";

import {useStore} from "vuex";

const store = useStore();
const props = defineProps({

  modelValue: {}
})
</script>

<template>
  <div class="global-css_horizontal-form-layout-label-top">
    <MultiSearchDropDown
        placeholder="Title"
        :maxLength="50"
        :width="60"
        label="Title"
        :label-top="true"
        :labelWidth="20"
        :allowCustomValue="false"
        :disableFilter="true"
        :selectPrimitiveValue="true"
        v-model="props.modelValue.title"
        :data-source="store.state.contactTitleSelection">
    </MultiSearchDropDown>
    <TextInput
        v-model="modelValue.firstName"
        :maxLength="50"
        :label-top="true"
        :width="200"
        :required-field="true"
        label="First Name">
    </TextInput>
    <TextInput
        v-model="modelValue.lastName"
        :maxLength="50"
        :label-top="true"
        :width="280"
        :required-field="true"
        label="Last Name">
    </TextInput>
    <TextInput
        v-model="modelValue.phone"
        :maxLength="50"
        :label-top="true"
        :width="280"
        label="Phone">
    </TextInput>
    <TextInput
        v-model="modelValue.email"
        :maxLength="50"
        :label-top="true"
        :width="280"
        label="Email">
    </TextInput>
  </div>

</template>

<style scoped lang="scss">

</style>
